<script setup lang="ts">
    import FilterSelectorBar from '@/components/ui/FilterSelectorBar.ce.vue';
    import formKitConfig from '@/formkit';
    import { FormKitProvider, FormKitRoot, defaultConfig } from '@formkit/vue';
    import Dropdown from '@shared/components/form/dropdown.vue';

    const props = defineProps<{
        maxGuestAmount?: number
        minGuestAmount?: number
        guestAmountStep?: number
    }>();

    const { t } = useI18n();

    const { venueEventTypes } = storeToRefs(useWidgetVenueStore());
    const { eventTypeFilter } = storeToRefs(useWidgetFilterStore());

    const eventTypes = computed(() => venueEventTypes.value
        .map(value => ({
            value: `${value.id}`,
            label: value.name,
        }))
        .sort((itemA, itemB) => itemA.label.localeCompare(itemB.label)));
</script>

<template>
    <div class="filter-bar">
        <FormKitProvider :config="defaultConfig(formKitConfig)">
            <FormKitRoot>
                <FormKit
                    type="form"
                    name="filterForm"
                    :actions="false"
                >
                    <Dropdown
                        v-model="eventTypeFilter"
                        :placeholder="t('widget.form.all-events')"
                        :options="eventTypes"
                        name="eventType"
                        label-hidden
                    />
                </FormKit>
            </FormKitRoot>
        </FormKitProvider>
        <FilterSelectorBar
            :max-guest-amount="maxGuestAmount"
            :min-guest-amount="minGuestAmount"
            :guest-amount-step="guestAmountStep"
            class="filter-bar__actions"
        />
    </div>
</template>

<style scoped lang="scss">
.filter-bar {
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    border-block-end: 1px solid var(--border-tertiary);
    font-size: var(--font-medium);
    gap: var(--spacing-02);
    inline-size: 100%;
    inset-block-start: 0;
    padding-block: var(--spacing-04);
    padding-inline: var(--spacing-03);

    @include min-width(md) {
        padding-inline: var(--spacing-05);
    }

    @include min-width(lg) {
        flex-direction: row;
        padding-inline: var(--spacing-07);
    }

    &__actions {
        flex: 2;
    }

    .formkit-form {
        flex: 1;

        .dropdown {
            font-size: var(--font-regular);
            inline-size: 100%;
        }
    }
}
</style>
